import { useEffect, useState } from 'react'
import { FomLogo } from './Bausteine'
import { konferenz } from '@/data/inhalte'

/** Oben fest: im Aufmacher durchsichtig, beim Scrollen dunkel mit Termin und Anmeldeknopf. */
export default function Kopfleiste({ format = konferenz.format, knopf = 'Anmelden' }: Readonly<{ format?: string; knopf?: string }>) {
  const [fest, setFest] = useState(false)

  useEffect(() => {
    const pruefen = () => setFest(window.scrollY > 40)
    pruefen()
    window.addEventListener('scroll', pruefen, { passive: true })
    return () => window.removeEventListener('scroll', pruefen)
  }, [])

  return (
    <header className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${fest ? 'bg-konf-nacht/85 shadow-[0_8px_30px_rgba(0,0,0,.18)] backdrop-blur-md' : ''}`}>
      <div className={`huelle-breit flex items-center justify-between gap-4 transition-[height] duration-300 ${fest ? 'h-16' : 'h-20 sm:h-28'}`}>
        <a href="#top" aria-label="Zum Seitenanfang" className="shrink-0">
          <FomLogo className={`transition-[height] duration-300 ${fest ? 'h-9' : 'h-11 sm:h-16'}`} />
        </a>
        <div className="flex items-center gap-5">
          <span className={`hidden text-[15px] text-white/80 transition-opacity duration-300 md:block ${fest ? 'opacity-100' : 'opacity-0'}`}>
            {konferenz.datum} · {konferenz.uhrzeit.split(' ')[0]} Uhr · {format}
          </span>
          {/* erst beim Scrollen - im Aufmacher steht „Jetzt anmelden“ schon groß */}
          <a
            href="#anmeldung"
            aria-hidden={!fest}
            tabIndex={fest ? undefined : -1}
            className={`knopf knopf-haupt knopf-klein transition-opacity duration-300 ${fest ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
          >
            {knopf}
          </a>
        </div>
      </div>
    </header>
  )
}
